// @flow
import React, { PureComponent } from 'react';
import { STATUS_DEFAULT } from 'constants/statusConstants';
import { getClubsNearby } from 'utils/clubUtils';
import { getDistanceFromLatLonInKm } from 'utils/distanceUtils';
import CardClub from 'components/fragments/card/CardClub';
import ButtonIcon from 'components/fragments/button/ButtonIcon';
import type { ClubPreviewType, ClubType } from 'types/Club';
import type { Status } from 'types/Status';

export type StateProps = {
  clubs: Array<ClubPreviewType>,
  status: Status
};

export type DispatchProps = {
  fetchClubs: () => void
};

type Props = {
  club: ClubType,
} & StateProps & DispatchProps;

type State = {
  page: number,
};

const CLUBS_NEARBY_KM = '40';
const CLUBS_NEARBY_NB = 10;

class ClubNearby extends PureComponent<Props, State> {
  state: State = {
    page: 0
  };

  componentDidMount() {
    const { fetchClubs } = this.props;

    if (this._shouldFetchClubs()) {
      fetchClubs();
    }
  }

  _shouldFetchClubs = () => {
    const { clubs, status } = this.props;
    return status === STATUS_DEFAULT || clubs.length === 0;
  }

  _renderClubs = (clubs: Array<ClubPreviewType>): Array<*> => {
    const { club: currentClub } = this.props;
    return clubs.map((club: ClubPreviewType, index: number) => {
      return (
        <CardClub
          key={index}
          club={club}
          distance={getDistanceFromLatLonInKm(currentClub.lat, currentClub.long, club.lat, club.long)} />
      );
    });
  }

  _setPage = (page: number) => (e: MouseEvent) => {
    e.preventDefault();
    this.setState({ page });
  };

  render() {
    const { status, club, clubs: allClubs } = this.props;
    const clubs = getClubsNearby(allClubs, club, CLUBS_NEARBY_KM, CLUBS_NEARBY_NB);
    const displayedClubs = clubs.slice(this.state.page * 3, 4 + this.state.page * 3);
    const maxPage = Math.max(Math.ceil(clubs.length / 3) - 1, 0);

    if (status === STATUS_DEFAULT || clubs.length === 0) {
      return null;
    }

    return (
      <div className="col">
        <div className="box block-carousel mb-6 mb-md-7 mb-lg-8 mt-lg-4">
          <h3 className="mb-3 ft-400">Clubs aux alentours</h3>
          <div className="carousel">
            <div className="carousel__nav">
              <ButtonIcon
                label={null}
                url={null}
                icon="icon-arrow-left"
                isDisabled={this.state.page === 0}
                onClick={this._setPage(this.state.page - 1)}
                titleSEO="Précédent" />
              <ButtonIcon
                label={null}
                url={null}
                icon="icon-arrow-right"
                isDisabled={this.state.page === maxPage}
                onClick={this._setPage(this.state.page + 1)}
                titleSEO="Suivant" />
            </div>
            <div className="carousel__wrapper">
              {this._renderClubs(displayedClubs)}
            </div>
          </div>
        </div>
      </div>
    );
  }

}

export default ClubNearby;
